module.exports = __webpack_public_path__ + "97345d4ce497c8b9a2614870ff963609.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-29.png
// module id = 1541
// module chunks = 0